export default {
    USER_ID : "user_oVLAyfMkwRFO7j8VGtpnn",
    TOKEN : "ea2511e49698f1f508b7e4939d827b52",
    SERVICE_ID : "gmail",
    TEMPLATE_ID : "emailtemplatenewsletter",
    }